import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import moment from 'moment';
import { nanoid } from 'nanoid';
import { useMemo, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { timeNotationSelector } from 'selectors/current_user';
import { formatTime } from 'services/time_format';
const daysContainerCss = "d1u0wpmw";
const DaysContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(daysContainerCss, props.className)} />;
});
const dayIconCss = "d1nqk6g3";
const DayIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dayIconCss, props.className)} />;
});
const dayContainerCss = "d1l7tm86";
const DayContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dayContainerCss, props.className)} />;
});
const containerCss = "cj923vd";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const disabledWeekdayCss = "d1daacy6";
const DisabledWeekday = forwardRef((props, ref) => {
  const size = 'small';
  const color = 'muted';
  return <BodyText ref={ref} {...props} size={size} color={color} className={classNames(disabledWeekdayCss, props.className)}>
      {I18n.t('publisher.event_types.availability.unavailable')}
    </BodyText>;
});
const dashCss = "d1tb7vpz";
const Dash = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dashCss, props.className)}>-</Component>;
});
const timeInputsContainerCss = "t1iggr12";
const TimeInputsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timeInputsContainerCss, props.className)} />;
});
const enabledWeekdayContainerCss = "e1nckzqy";
const EnabledWeekdayContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(enabledWeekdayContainerCss, props.className)} />;
});
const EnabledWeekday = ({
  intervals
}) => <EnabledWeekdayContainer data-component="time-container">
    {intervals.map(({
    from,
    to,
    id
  }) => <TimeInputsContainer key={id}>
          <BodyText size="medium">{from}</BodyText>
          <Dash />
          <BodyText size="medium">{to}</BodyText>
        </TimeInputsContainer>)}
  </EnabledWeekdayContainer>;
const WdayRule = ({
  intervals
}) => {
  const timeNotation = useSelector(timeNotationSelector);
  const defaultTimeFormat = 'HH:mm';
  const intervalsWithIds = useMemo(() => intervals.map(interval => ({
    from: formatTime(moment(interval.from, defaultTimeFormat), timeNotation),
    to: formatTime(moment(interval.to, defaultTimeFormat), timeNotation),
    id: nanoid(4)
  })), [intervals, timeNotation]);
  return <Container>
      {intervals.length > 0 ? <EnabledWeekday intervals={intervalsWithIds} /> : <DisabledWeekday />}
    </Container>;
};
const Day = ({
  wday,
  days
}) => {
  const intervals = days[wday];
  const abbrDayNames = I18n.t('date.abbr_day_names_hash');
  return <DayContainer key={wday} data-component={wday}>
      <DayIcon>
        {abbrDayNames[wday].slice(0, 1)}
      </DayIcon>
      <WdayRule intervals={intervals} />
    </DayContainer>;
};
export const ReadOnlyHoursView = ({
  days
}) => <DaysContainer data-component="days-container">
    {Object.keys(days).map(wday => <Day key={wday} wday={wday} days={days} />)}
  </DaysContainer>;

require("./read_only_hours_view.wyw-in-js.css!=!../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./read_only_hours_view.js");